import React from 'react';
import { motion } from 'framer-motion';
import { Waves, Wind, Anchor, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
const activities = [{
  id: 'sup',
  title: 'SUP / Race',
  description: 'חתירה בעמידה על גלשן סאפ. פעילות המשלבת כושר גופני, שיווי משקל וחיבור לטבע. מתאים לכל הגילאים ולכל רמות הכושר. הצטרפו לקבוצות ולקהילה השוקקת שלנו.',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7FYEnEHxXy4Ajs6r7s98nx/939A4238.jpg',
  icon: Waves,
  color: 'from-blue-500 to-cyan-400',
  path: '/sup'
}, {
  id: 'surfski',
  title: 'קיאק Surfski',
  description: 'חתירה מהירה ומהנה בקיאק ספורטיבי. חוויה אדרנלינית ומאתגרת הדורשת מיומנות וטכניקה. הצטרפו לקבוצות האימון שלנו.',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7vRPckyZqmqZUztC54T3ts/image_%287%29.png',
  icon: Anchor,
  color: 'from-indigo-500 to-blue-500',
  path: '/surfski'
}, {
  id: 'wingfoil',
  title: 'Wing Foil',
  description: 'הדבר הבא בעולם הגלישה! שילוב של גלישת רוח וריחוף מעל המים. קורסים למתחילים ומתקדמים עם הציוד החדיש ביותר.',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/co1SZT3RTYumCS8rU85uzt/IMG-20250502-WA0017.jpg',
  icon: Wind,
  color: 'from-cyan-500 to-teal-400',
  path: '/wingfoil'
}];
export function ActivitySection() {
  return <section id="activities" className="py-24 bg-gray-50 relative overflow-hidden" data-id="element-45">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-blue-50/50 -skew-x-12 translate-x-20" data-id="element-46" />
      <div className="absolute bottom-0 left-0 w-1/4 h-1/2 bg-cyan-50/50 -skew-x-12 -translate-x-20" data-id="element-47" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-48">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-49">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4" data-id="element-50">
            הפעילויות שלנו
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-51">
            מגוון פעילויות ימיות לכל הרמות, בחוף היפה ביותר בכנרת
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-52">
          {activities.map((activity, index) => <motion.div key={activity.id} id={activity.id} className="group relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 h-full flex flex-col" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.6
        }} whileHover={{
          y: -10
        }} data-id="element-53">
              {/* Image Container */}
              <div className="relative h-64 overflow-hidden" data-id="element-54">
                <div className={`absolute inset-0 bg-gradient-to-t ${activity.color} opacity-20 group-hover:opacity-10 transition-opacity z-10`} data-id="element-55" />
                <img src={activity.image} alt={activity.title} className={`w-full h-full transform group-hover:scale-110 transition-transform duration-700 ${activity.id === 'wingfoil' ? 'object-cover scale-[2]' : 'object-cover'}`} data-id="element-56" />
                <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm p-3 rounded-full z-20 shadow-sm" data-id="element-57">
                  <activity.icon className="w-6 h-6 text-[#0A5F8F]" data-id="element-58" />
                </div>
              </div>

              {/* Content */}
              <div className="p-8 flex-1 flex flex-col" data-id="element-59">
                <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-60">
                  {activity.title}
                </h3>
                <p className="text-gray-600 mb-6 flex-1 leading-relaxed" data-id="element-61">
                  {activity.description}
                </p>
                <Link to={activity.path} className="flex items-center text-[#0A5F8F] font-bold group-hover:gap-2 transition-all" data-id="element-62">
                  למידע נוסף
                  <ArrowLeft className="w-4 h-4 mr-2 transition-transform group-hover:-translate-x-1" data-id="element-63" />
                </Link>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}